import React from 'react';
import Modal from 'react-modal';
import styled, { useTheme } from 'styled-components';

import { Button, Splash } from '..';
import { DeleteIcon } from '../../../assets/Modal';
import { useGlobalModalContext } from '../../../context/GlobalModal';
import { DivFlex, FlexColumn } from '../../Typhography';

const DialogStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    maxWidth: '500px',
    borderRadius: '20px',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const DialogTitle = styled.h1`
  text-align: center;
`;

const ButtonClose = styled.div`
  position: absolute;
  color: ${(props) => props.theme.colors.gray};
  top: 10px;
  right: 20px;
  cursor: pointer;
  font-size: 20px;
`;

const DialogFooter = styled(DivFlex)`
  margin-left: 50px;
`;

const CancelButton = styled.div`
  color: ${(props) => props.theme.colors.gray};
  ${(props) => props.theme.typography.fontBold};
  cursor: pointer;
`;

const Text = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.gray};
`;

export const DialogModal = () => {
  const { hideModal, store } = useGlobalModalContext();
  const { colors } = useTheme();
  const [loading, setLoading] = React.useState<boolean>(false);
  const { modalProps } = store || {};
  const { title, text, cancelButtonText, submitButtonText, onSubmit } = modalProps || {};

  const handleOnSubmit = async () => {
    setLoading(true);
    await onSubmit();
    setLoading(false);

    hideModal();
  };

  return (
    <Modal
      overlayClassName="myoverlay"
      isOpen={true}
      ariaHideApp={false}
      onRequestClose={hideModal}
      style={DialogStyles}
    >
      <FlexColumn>
        <img src={DeleteIcon} />
        <ButtonClose onClick={hideModal}>X</ButtonClose>
        <DialogTitle>{title}</DialogTitle>
        <Text>{text}</Text>
        <DialogFooter>
          <CancelButton onClick={hideModal}>{cancelButtonText}</CancelButton>
          <Button
            margin={30}
            color="white"
            width={140}
            height={40}
            variant="danger"
            onClick={handleOnSubmit}
          >
            {loading ? <Splash color={colors.white} height={25} width={25} /> : submitButtonText}
          </Button>
        </DialogFooter>
      </FlexColumn>
    </Modal>
  );
};
